import React from "react";
import ManuOperation from "./navOperationRoom/ManuOperation";
import Home from "../public/Home";

export default function HomeOperation() {
    return(
        <>
            <ManuOperation menuActive={'homeoperation'} />
            <Home roleUser={'Laboratory'}/>
        </>
    )
}